import { useNavigate } from "react-router-dom";
import Button from "components/ui/Button";

const IconLock = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const IconHome = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #F5F6FA 0%, #EEF0F8 100%)",
        padding: 32,
      }}
    >
      <div
        style={{
          background: "rgba(255,255,255,0.78)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.6)",
          borderRadius: 24,
          padding: "48px 40px",
          boxShadow: "0 20px 60px rgba(15,23,42,0.08), 0 4px 16px rgba(15,23,42,0.04)",
          textAlign: "center",
          maxWidth: 500,
          width: "100%",
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 72, height: 72,
            borderRadius: 18,
            background: "linear-gradient(135deg, var(--danger-bg), #FFE4E6)",
            color: "var(--danger)",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 20px",
            boxShadow: "0 8px 24px rgba(220,38,38,0.18)",
          }}
        >
          <IconLock />
        </div>

        <div
          className="t-display-lg"
          style={{ color: "#0F172A", lineHeight: 1, fontSize: 64, marginBottom: 8 }}
        >
          403
        </div>
        <h1 className="t-heading-md" style={{ color: "#0F172A", margin: 0 }}>Access denied</h1>
        <p className="t-body-sm t-muted" style={{ margin: "12px 0 24px", maxWidth: 380, marginInline: "auto" }}>
          You don't have permission to view this page. If you believe this is an error, please contact your administrator or try logging in with a different account.
        </p>

        <Button variant="primary" leftIcon={<IconHome />} onClick={() => navigate("/home")}>
          Back to home
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
